import { PeriodModel } from './PeriodModel';

/**
 * Created by dstoian on 27/03/2017.
 */

export class DateUtil {
  public static daysPerMonth = new Map<number, number>();

  // Format Date to YYYY-MM-DD
  public static formatDate(date: Date, language) {
    const mm = date.getMonth() + 1;
    const dd = date.getDate();

    if (language && 'fr' === language) {
      return [(dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('/');
    }

    return [date.getFullYear(),
      (mm > 9 ? '' : '0') + mm,
      (dd > 9 ? '' : '0') + dd
    ].join('-');
  }

  // convert a string formatted "YYYY-MM-DD" into a date object
  public static fromStringToDate(stringdate: string): Date {
    const parts = stringdate.split('-');
    const month = parts[1].toString();
    const yearNumber = Number(parts[0]);
    let monthNumber = 0;
    if (month[0] === '0') {
      monthNumber = +month[1];
    } else {
      monthNumber = +parts[1];
    }
    const numberOfDays = Number(parts[2]);
    return new Date(yearNumber, monthNumber - 1, numberOfDays);
  }
  // convert a string formatted "YYYY-MM-DD" into a date object
  public static fromStringToDateSecond(stringdate: string): Date {
    const parts = stringdate.split(',');
    const month = parts[1].toString();
    const yearNumber = Number(parts[0]);
    let monthNumber = 0;
    if (month[0] === '0') {
      monthNumber = +month[1];
    } else {
      monthNumber = +parts[1];
    }
    const numberOfDays = Number(parts[2]);
    return new Date(yearNumber, monthNumber - 1, numberOfDays);
  }

  public static periodBetweenDates(startDate: string, endDate: string): PeriodModel {
    DateUtil.initDaysPerMonths();
    const a = new Date(startDate);
    const b = new Date(endDate);
    let numberOfDays = 0;
    let numberOfYears = b.getFullYear() - a.getFullYear();
    let numberOfMonths = (b.getMonth() - a.getMonth() + 12) % 12;
    if (a.getMonth() === b.getMonth() && a.getTime() > b.getTime()) {
      numberOfYears--;
    }
    if (a.getMonth() > b.getMonth()) {
      numberOfYears--;
    }
    if (a.getDate() > b.getDate()) {
      numberOfMonths--;
      if (numberOfMonths < 0) {
        numberOfMonths = 11;
      }
    }
    if (b.getDate() < a.getDate()) {
      let numberOfDaysPerMonth = DateUtil.daysPerMonth.get(a.getMonth());
      if (a.getMonth() === 1 && DateUtil.checkLeapYear(a.getFullYear())) {
        numberOfDaysPerMonth++;
      }
      numberOfDays = numberOfDaysPerMonth - a.getDate() + b.getDate();
    } else {
      numberOfDays = b.getDate() - a.getDate();
    }
    return new PeriodModel(numberOfYears, numberOfMonths, numberOfDays);
  }

  public static checkLeapYear(year: number): boolean {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return true;
    }
    return false;
  }

  public static initDaysPerMonths() {
    DateUtil.daysPerMonth.set(0, 31);
    DateUtil.daysPerMonth.set(1, 28);
    DateUtil.daysPerMonth.set(2, 31);
    DateUtil.daysPerMonth.set(3, 30);
    DateUtil.daysPerMonth.set(4, 31);
    DateUtil.daysPerMonth.set(5, 30);
    DateUtil.daysPerMonth.set(6, 31);
    DateUtil.daysPerMonth.set(7, 31);
    DateUtil.daysPerMonth.set(8, 30);
    DateUtil.daysPerMonth.set(9, 31);
    DateUtil.daysPerMonth.set(10, 30);
    DateUtil.daysPerMonth.set(11, 31);
  }

  // returns 0 if the 2 dates are equal, 1 if the first date is greater than the second one or -1 when it's the opposite
  public static compareLocalDates(first: Date, second: Date): number {
    if (first.getFullYear() > second.getFullYear()) {
      return 1;
    } else if (first.getFullYear() < second.getFullYear()) {
      return -1;
    } else {
      if (first.getMonth() > second.getMonth()) {
        return 1;
      } else if (first.getMonth() < second.getMonth()) {
        return -1;
      } else {
        if (first.getDate() > second.getDate()) {
          return 1;
        } else if (first.getDate() < second.getDate()) {
          return -1;
        } else {
          return 0;
        }
      }
    }
  }

  /* From moment-precise-range plugin */
   public static preciseDiff(d1, d2): PeriodModel {
  //   let m1 = moment(d1);
  //   let m2 = moment(d2);
  //
  //   if (m1.isSame(m2)) {
  //     return new PeriodModel(0, 0, 0);
  //   }
  //   if (m1.isAfter(m2)) {
  //     const tmp = m1;
  //     m1 = m2;
  //     m2 = tmp;
  //   }
  //
  //   let yDiff = m2.year() - m1.year();
  //   let mDiff = m2.month() - m1.month();
  //   let dDiff = m2.date() - m1.date();
  //   let hourDiff = m2.hour() - m1.hour();
  //   let minDiff = m2.minute() - m1.minute();
  //   let secDiff = m2.second() - m1.second();
  //
  //   if (secDiff < 0) {
  //     secDiff = 60 + secDiff;
  //     minDiff--;
  //   }
  //   if (minDiff < 0) {
  //     minDiff = 60 + minDiff;
  //     hourDiff--;
  //   }
  //   if (hourDiff < 0) {
  //     hourDiff = 24 + hourDiff;
  //     dDiff--;
  //   }
  //   if (dDiff < 0) {
  //     const daysInLastFullMonth = moment(m2.year() + '-' + (m2.month() + 1), 'YYYY-MM')
  //       .subtract(1, 'months').daysInMonth();
  //     if (daysInLastFullMonth < m1.date()) { // 31/01 -> 2/03
  //       dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
  //     } else {
  //       dDiff = daysInLastFullMonth + dDiff;
  //     }
  //     mDiff--;
  //   }
  //   if (mDiff < 0) {
  //     mDiff = 12 + mDiff;
  //     yDiff--;
  //   }
  //
  //   const result = [];
  //
  //   moment.relativeTimeThreshold('s', 60);
  //   moment.relativeTimeThreshold('m', 60);
  //   moment.relativeTimeThreshold('h', 23);
  //   moment.relativeTimeThreshold('dd', 28);
  //   moment.relativeTimeThreshold('dm', 45);
  //   moment.relativeTimeThreshold('dy', 365);
  //
  //   if (yDiff) {
  //     result.push(moment.duration(yDiff, 'year').humanize());
  //   }
  //   if (mDiff) {
  //     result.push(moment.duration(mDiff, 'month').humanize());
  //   }
  //   if (dDiff) {
  //     result.push(moment.duration(dDiff, 'day').humanize());
  //   }
  //   if (hourDiff) {
  //     result.push(moment.duration(hourDiff, 'hour').humanize());
  //   }
  //   if (minDiff) {
  //     result.push(moment.duration(minDiff, 'minute').humanize());
  //   }
  //   if (secDiff) {
  //     result.push(moment.duration(secDiff, 'second').humanize());
  //   }
  //
  //   const period = new PeriodModel(0, 0, 0);
  //   period.years = moment.duration(yDiff, 'year').asYears();
  //   period.months = moment.duration(mDiff, 'month').asMonths();
  //   period.days = moment.duration(dDiff, 'day').asDays();
  //
     const period = new PeriodModel(0, 0, 0);
     return period;
   }

  constructor() {
  }

}
